import {useQuery, type UseQueryOptions} from '@tanstack/react-query'
import {type AxiosError} from 'axios'

import {riskSurveyQueries} from '../../api'
import type {RiaDetailDto} from '../../types'

import {riskSurveyQueryKeys} from './riskSurveyQueryKeys'

export const useRiaDetail = (
  riaId: string,
  options?: Omit<UseQueryOptions<RiaDetailDto, AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<RiaDetailDto, AxiosError>({
    queryKey: riskSurveyQueryKeys.rias.detail(riaId),
    queryFn: ({signal}) => riskSurveyQueries.getRiaDetail(riaId, signal),
    enabled: !!riaId,
    staleTime: 60_000,
    gcTime: 300_000,
    ...options
  })
}
